// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../static/js/component-1.0.9.js'
import MyAction from './actions/index'

Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.prototype.$action = MyAction;
Vue.prototype.$message = ElementUI.Message;

// 添加文字水印 {className, text}
Vue.prototype.$mark = function (option) {
  if(option.backgroundSize){
    document.getElementsByClassName(option.className)[0].style.backgroundSize = option.backgroundSize;
  }
  document.getElementsByClassName(option.className)[0].style.backgroundImage = `url("data:image/svg+xml,%3Csvg width='${option.width?option.width:'120'}' height='${option.height?option.height:'120'}' xmlns='http://www.w3.org/2000/svg'%3E%3Ctext x='${option.x?option.x:88}%25' y='${option.y?option.y:15}%25' font-size='${option.font_size?option.font_size:28}'  font-family='PingFang SC, Microsoft YaHei, Arial, sans-serif' fill='%23${option.color?option.color:'cccccc'}' fill-opacity='0.${option.opacity?option.opacity:5}' text-anchor='middle' dominant-baseline='middle' transform='${option.transform?option.transform:'rotate(-45, 100 100)'}'%3E${option.text}%3C/text%3E%3C/svg%3E")`
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js